import script from "./ModalsContainer.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalsContainer.vue?vue&type=script&lang=ts&setup=true"

import "./ModalsContainer.vue?vue&type=style&index=0&id=708c7bbc&lang=scss"

const __exports__ = script;

export default __exports__